module.exports = __webpack_public_path__ + "img/logo-01.8b4854ad.png";